export default __webpack_public_path__ + "static/1761-7d970973f899d3e685fde5c0b407c92e.gif";